export default "/assets/images/big-sneeze4.eab8e64a3f29ae46.png";